module.exports = __webpack_public_path__ + "b00ed02711cd6d837a260e206deefc3c.fbx";